var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33356H0V26.6664H32V5.33356Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.2901H0V19.7099H32V12.2901Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.71H0V26.6665H32V19.71Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0918 11.3624V16.6834C8.0918 19.7102 12.046 20.6376 12.046 20.6376C12.046 20.6376 16.0001 19.7101 16.0001 16.6834V11.3624H8.0918Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13293 11.5184V16.6397C9.13293 16.9817 9.20887 17.3047 9.35937 17.6075C10.8525 17.6075 13.0843 17.6075 14.7325 17.6075C14.883 17.3047 14.9589 16.9817 14.9589 16.6397V11.5184H9.13293Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8314 15.0892H12.4923V14.1965H13.3851V13.3038H12.4923V12.4111H11.5996V13.3038H10.707V14.1965H11.5996V15.0892H10.2605V15.9819H11.5996V16.8746H12.4923V15.9819H13.8314V15.0892Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.577 18.8536C11.1522 19.215 11.7432 19.425 12.0459 19.5183C12.3485 19.425 12.9395 19.2151 13.5147 18.8536C14.0949 18.489 14.5016 18.072 14.7325 17.6074C14.4778 17.4272 14.1671 17.321 13.8314 17.321C13.7091 17.321 13.5904 17.3355 13.4762 17.362C13.2343 16.8123 12.6851 16.4283 12.046 16.4283C11.4068 16.4283 10.8577 16.8123 10.6157 17.362C10.5016 17.3355 10.3827 17.321 10.2606 17.321C9.92487 17.321 9.61412 17.4273 9.3595 17.6074C9.59018 18.072 9.99687 18.489 10.577 18.8536Z",
    fill: "#0052B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.67a9c2f3.svg";
export { ForwardRef as ReactComponent };